import React from 'react';
import Skeleton from 'react-loading-skeleton';

import defaultCompanyCoverImage from 'assets/defaultCompanyCoverImage.svg';
import kiraLogoWhite from 'assets/kiraLogoWhite.png';
import { t } from 'locales/i18n';

interface OverviewAssessmentHeroProps {
  assessmentName: string;
  companyCoverImage?: string;
  companyCoverLogo?: string;
  createdAt: string;
  isLoading: boolean;
  isPractice?: boolean;
  numberOfApplicants: number;
  updatedAt: string;
}

const OverviewAssessmentHero = ({
  assessmentName,
  companyCoverImage,
  companyCoverLogo,
  createdAt,
  isLoading,
  isPractice,
  numberOfApplicants,
  updatedAt,
}: OverviewAssessmentHeroProps) => {
  const backgroundImage = companyCoverImage || defaultCompanyCoverImage;
  const lightLogo = companyCoverLogo || kiraLogoWhite;

  return (
    <div
      className="h-[22rem] overflow-hidden rounded-lg bg-kira-blue-300 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${backgroundImage})` }}
      data-testid="bcg-image-div"
    >
      <div
        className={`flex h-full flex-col justify-between p-6 ${
          companyCoverImage && 'bg-gradient-to-r from-black/90 to-black/5'
        }`}
      >
        <div>
          {isLoading ? (
            <Skeleton
              height={40}
              width="20%"
              baseColor="rgba(255, 255, 255, 0.1)"
              highlightColor="rgba(255, 255, 255, 0.7)"
            />
          ) : (
            <img
              src={lightLogo}
              alt={t('Company light logo')}
              className="h-10"
              data-testid="light-logo-header"
            />
          )}
        </div>

        {isLoading ? (
          <Skeleton
            count={3}
            baseColor="rgba(255, 255, 255, 0.1)"
            highlightColor="rgba(255, 255, 255, 0.7)"
          />
        ) : (
          <div className="text-white">
            {!isPractice && (
              <p className="prose-body-lg-reg">
                {numberOfApplicants}{' '}
                {numberOfApplicants === 1 ? t('applicant') : t('applicants')}
              </p>
            )}
            <h2 className="prose-display-1">{assessmentName}</h2>
            <div className="prose-body-lg-reg flex">
              <p data-testid="assessment-created-date">
                {t('Created on')} {createdAt}
              </p>
              <span className="mx-2">·</span>
              <p>
                {t('Last updated')} {updatedAt}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OverviewAssessmentHero;
